import { Moment } from 'moment/moment';
import { SelectOption } from '../../../global';

export enum FinanceApiFilterType {
  DEAL_DATE = 'DEAL_DATE',
  SALES_REP = 'SALES_REP',
  LOCATION = 'LOCATION',
}

export enum FinanceFilterType {
  DEAL_DATE = 'DEAL_DATE',
  SALES_REP = 'SALES_REP',
  LOCATION = 'LOCATION',
}

export type FinanceFilters = {
  [FinanceFilterType.DEAL_DATE]: {
    from: Moment;
    to: Moment;
  };
  [FinanceFilterType.SALES_REP]: SelectOption[];
  [FinanceFilterType.LOCATION]: SelectOption[];
};

export interface FinanceFilterCardProps {
  meta?: Partial<Record<FinanceFilterType, SelectOption[]>>;
}

export type FinanceFiltersFormattedForPayload = {
  [FinanceApiFilterType.DEAL_DATE]: {
    from: string;
    to: string | null;
  };
  [FinanceApiFilterType.SALES_REP]: (string | null)[];
  [FinanceApiFilterType.LOCATION]: (string | null)[];
};

export type FinanceFiltersPayloadItem = {
  [K in keyof FinanceFiltersFormattedForPayload]: {
    key: K;
    value: FinanceFiltersFormattedForPayload[K];
  };
}[keyof FinanceFiltersFormattedForPayload];

export type FinanceFiltersPayload = FinanceFiltersPayloadItem[];
